/**
 * Order/fill side vocabulary is inconsistent across backend payloads:
 * `Kcc20Order.side` uses `ask`/`bid`, while activity rows expose `orderSide`
 * plus `takerSide` explicitly.
 * These helpers normalize that vocabulary into a single display label.
 */
export function kcc20SideLabel(
  side?: string | null,
): 'Buy' | 'Sell' | 'Cross' | '--' {
  if (side === 'buy' || side === 'bid') return 'Buy';
  if (side === 'sell' || side === 'ask') return 'Sell';
  if (side === 'cross') return 'Cross';
  return '--';
}

export function kcc20SideClass(side?: string | null): string {
  const label = kcc20SideLabel(side);
  if (label === 'Buy') return 'side-tag side-tag--buy';
  if (label === 'Sell') return 'side-tag side-tag--sell';
  if (label === 'Cross') return 'side-tag side-tag--cross';
  return 'side-tag';
}
